"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapPoint = void 0;
/**
 * @internal
 */
var SnapPoint;
(function (SnapPoint) {
    SnapPoint["TopLeft"] = "tl";
    SnapPoint["TopCenter"] = "tc";
    SnapPoint["TopRight"] = "tr";
    SnapPoint["CenterLeft"] = "cl";
    SnapPoint["CenterCenter"] = "cc";
    SnapPoint["CenterRight"] = "cr";
    SnapPoint["BottomLeft"] = "bl";
    SnapPoint["BottomCenter"] = "bc";
    SnapPoint["BottomRight"] = "br";
})(SnapPoint = exports.SnapPoint || (exports.SnapPoint = {}));
//# sourceMappingURL=positioning.js.map